import React from 'react';
import { motion } from 'framer-motion';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  hoverEffect?: boolean;
  onClick?: () => void;
}
export function Card({
  children,
  className = '',
  hoverEffect = true,
  onClick
}: CardProps) {
  return <motion.div whileHover={hoverEffect ? {
    y: -5,
    boxShadow: '0 10px 30px -10px rgba(43, 199, 183, 0.15)',
    borderColor: 'rgba(43, 199, 183, 0.4)'
  } : {}} transition={{
    duration: 0.3
  }} className={`
        bg-[#1c3f4d]/40 
        backdrop-blur-sm 
        border border-white/5 
        rounded-organic-lg 
        overflow-hidden 
        relative
        ${onClick ? 'cursor-pointer' : ''}
        ${className}
      `} onClick={onClick} data-id="element-244">
      {/* Neural mesh overlay pattern */}
      <div className="absolute inset-0 opacity-5 bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-vitalityTeal via-transparent to-transparent pointer-events-none" data-id="element-245" />

      <div className="relative z-10" data-id="element-246">{children}</div>
    </motion.div>;
}